import { UmbracoPlayerComponent } from "front-end/components/video-box/factories/umbraco/umbraco-player.component";
import { IVideoPlayerComponent } from "front-end/components/video-box/factories/video-player.component";
import { IVideoPlayerFactory } from "front-end/components/video-box/factories/video-player.factory";
import { VideoPlayerFactoryBase } from "front-end/components/video-box/factories/video-player.factory.base";
import { Observable, of } from "rxjs";

class UmbracoVideoPlayerFactory extends VideoPlayerFactoryBase implements IVideoPlayerFactory {
    public createPlayer(frameId: string): Observable<IVideoPlayerComponent> {
        const videoFrameElement =  this.setupFrame(frameId).get(0) as HTMLVideoElement;

        const player = new UmbracoPlayerComponent();
        player.init(videoFrameElement);

        return of(player);
    }
}

export const umbracoVideoPlayerFactory = new UmbracoVideoPlayerFactory();
